import React from 'react';
import { Navigate } from "react-router-dom";

const GuardedRoute = ({ component: Component }) => {
    let ret = localStorage.getItem("token") ? <Component /> : <Navigate to="/login" />
    return ret
}

export default GuardedRoute;